module.exports = __webpack_public_path__ + "static/img/browser.825be84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/browser.png
// module id = FBwB
// module chunks = 7